module.exports = __webpack_public_path__ + "static/media/tutorial_en_0.88798844.png";